import styled from "styled-components";

const Titulo = styled.div`
  text-align: left;
  font-size: 20px;
  color: ${(props) => props.theme.colors.secondary};
  font-weight: bold;
  margin-bottom: 10px;
`;

const Erro = styled.div`
  text-align: left;
  color: ${(props) => props.theme.colors.brandDanger};
`;

const TituloInput = styled.div`
  text-align: left;
  margin: 4rem 0 2.4rem 0;
`;

const Texto = styled.div`
  text-align: left;
  color: ${(props) => props.theme.colors.tertiary};
  text-align: justify;
  margin-bottom: 5rem;
  font-size: 14px;
`;

const NumeroAtual = styled.div`
  margin-top: 10px;
  text-align: left;
  color: ${(props) => props.theme.colors.tertiary};
  text-align: justify;
  margin-bottom: 2.4rem;
  font-size: 14px;
`;

const Botoes = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  .cancelar {
    color: ${(props) => props.theme.colors.primary};
    cursor: pointer;
  }
`;

const Planos = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;

  .periodicidade, .plano {
    width: 100%;

    .titulo {
      color: ${(props) => props.theme.colors.tertiary};
      text-align: center;
      cursor: pointer;
    }

    .linha {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 2.5px;

      div {
        height: 2.5px;
        background-color: ${(props) => props.theme.colors.elements};
        width: 100%;
      }
    }

    &.selecionado {
      .titulo {
        font-weight: bold;
        color: ${(props) => props.theme.colors.primary};
      }

      .linha {
        div {
          height: 2.5px;
          background-color: ${(props) => props.theme.colors.primary};
        }
      }
    }
  }
`;

const InputsContainer = styled.div`
  > * {
    margin-top: 20px;
  }
`;

const ConteudoPlano = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  .html {
    width: 100%;
    .descontos {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .desconto {
      width: 50%;
      font-size: 16px;
      padding: 7px;
      margin-top: 20px;
      text-align: center;
      color: ${(props) => props.theme.colors.tertiary};
      font-weight: bold;
      background-color: ${(props) => props.theme.colors.white};
      border-radius: 5rem;
    }
    .desconto2 {
      width: 50%;
      font-size: 16px;
      padding: 7px;
      margin-top: 20px;
      text-align: center;
      color: white;
      font-weight: bold;
      background-color: #48A46D;
      border-radius: 5rem;
    }

    .texto-desconto {
      margin-top: 15px;
      text-align: center;
      font-size: 15px;
      color: ${(props) => props.theme.colors.tertiary};

      strong {
        font-size: 23px;
      }
    }

    .texto-final {
      text-align: justify;
      margin-top: 15px;
    }
  }
`;

export {
  Titulo,
  Erro,
  TituloInput,
  Texto,
  NumeroAtual,
  Botoes,
  Planos,
  InputsContainer,
  ConteudoPlano,
};
